export var GrammarType;

!function(GrammarType) {
    GrammarType.data = "data", GrammarType.signal = "signal", GrammarType.mark = "mark";
}(GrammarType || (GrammarType = {}));
//# sourceMappingURL=compilable-item.js.map
